export const onboardQueryKeys = {
  targetEntities: ['onboard', 'targetEntities'] as const,
  countries: ['onboard', 'countries'] as const,
  contractCategories: ['onboard', 'contractCategories'] as const,
  contractCategoryUsage: (id: number) => ['onboard', 'contractCategories', id, 'usage'] as const,
  contractConfigurations: ['onboard', 'contractConfigurations'] as const,
  contractTemplates: ['onboard', 'contractTemplates'] as const,
  emailTemplates: ['onboard', 'emailTemplates'] as const,
  emailTemplateSignatureOptions: ['onboard', 'emailTemplateSignatureOptions'] as const,
  placeholderRules: ['onboard', 'placeholderRules'] as const,
  systemFieldOptions: ['onboard', 'systemFieldOptions'] as const,
  users: ['onboard', 'users'] as const,
  offers: ['onboard', 'offers'] as const,
  offer: (id: number) => ['onboard', 'offers', id] as const,
  signedOfferPreview: (offerId: number) =>
    ['onboard', 'offers', offerId, 'signedOfferPreview'] as const,
  offerContractPreview: (offerId: number) =>
    ['onboard', 'offers', offerId, 'offerContractPreview'] as const,
  profileOffers: (profileId: number) => ['onboard', 'profiles', profileId, 'offers'] as const,
  profileActivities: (profileId: number) =>
    ['onboard', 'profiles', profileId, 'activities'] as const,
  profileRecruitSmartForms: (profileId: number) =>
    ['onboard', 'profiles', profileId, 'recruit_smart_forms'] as const,
  profileRecruitDocuments: (profileId: number) =>
    ['onboard', 'profiles', profileId, 'recruit_documents'] as const,
  profileApprovalSystemFields: (profileId: number) =>
    ['onboard', 'profiles', profileId, 'approval_system_fields'] as const,
  profileActivePortals: (profileId: number) =>
    ['onboard', 'profiles', profileId, 'active_portals'] as const,
  profileAvailableDocuments: (profileId: number) =>
    ['onboard', 'profiles', profileId, 'available_documents'] as const,
  recruitFormResponseAnswers: (formResponseId: number) =>
    ['onboard', 'recruit_form_responses', formResponseId, 'answers'] as const,
  onboardSmartFormAnswers: (offerId: number, itemId: string) =>
    ['onboard', 'offers', offerId, 'smart_form_answers', itemId] as const,
  profiles: ['onboard', 'profiles'] as const,
  profilesAll: ['onboard', 'profiles', 'all'] as const,
  profilesList: (
    page: number,
    limit: number,
    entityIds: number[] = [],
    archived = false,
    search = ''
  ) => ['onboard', 'profiles', page, limit, entityIds, archived, search] as const,
  profileEntityOptions: ['onboard', 'profileEntityOptions'] as const,
  profile: (id: number) => ['onboard', 'profiles', id] as const,
  resourceLists: (resourceType: string) => ['onboard', 'resources', resourceType] as const,
  departmentEntityOptions: ['onboard', 'departmentEntityOptions'] as const,
  approverEntityOptions: ['onboard', 'approverEntityOptions'] as const,
  approverDepartmentOptions: ['onboard', 'approverDepartmentOptions'] as const,
  approverAvailableDepartments: ['onboard', 'approverAvailableDepartments'] as const,
  documentEntityOptions: ['onboard', 'documentEntityOptions'] as const,
  documentCreatorOptions: ['onboard', 'documentCreatorOptions'] as const,
  documentCategoryOptions: ['onboard', 'documentCategoryOptions'] as const,
  offerTemplateEntityOptions: ['onboard', 'offerTemplateEntityOptions'] as const,
  offerTemplateCreatorOptions: ['onboard', 'offerTemplateCreatorOptions'] as const,
  offerTemplateCategoryOptions: ['onboard', 'offerTemplateCategoryOptions'] as const,
  resources: (resourceType: string, deleted = false) =>
    [...onboardQueryKeys.resourceLists(resourceType), deleted ? 'deleted' : 'active'] as const,
  offerDocuments: (profileId: number) =>
    [...onboardQueryKeys.resources('document'), 'offerProfile', profileId] as const,
  resource: (resourceType: string, id: number) =>
    ['onboard', 'resources', resourceType, id] as const,
  contractTemplate: (id: number) => ['onboard', 'contractTemplates', id] as const,
  // Create Offer's Offer file list, which includes the one-off contract `includeId` when set.
  // Its own segment keeps it apart from contractTemplate(id), a single template.
  offerFileContractTemplates: (includeId: number | null) =>
    ['onboard', 'contractTemplates', 'offerFile', includeId] as const,
  contractTemplatePreviewPdf: (id: number, mergeValues: Record<string, string>) =>
    ['onboard', 'contractTemplates', id, 'previewPdf', mergeValues] as const,
  contractTemplatePreviewSessionPdf: (token: string, mergeValues: Record<string, string>) =>
    ['onboard', 'contractTemplatePreviews', token, 'previewPdf', mergeValues] as const,
  contractTemplatePreviewRenderStatus: (token: string) =>
    ['onboard', 'contractTemplatePreviews', 'renders', token, 'status'] as const,
  contractTemplatePreviewRenderResult: (token: string) =>
    ['onboard', 'contractTemplatePreviews', 'renders', token, 'result'] as const,
  contractTemplateDeliveries: (templateId: number, page = 1, limit = 100) =>
    ['onboard', 'contractTemplateDeliveries', templateId, page, limit] as const,
  contractTemplateVersions: (templateId: number) =>
    ['onboard', 'contractTemplateVersions', templateId] as const,
  configuration: ['onboard', 'configuration'] as const,
  smartForm: (formId: number) => ['onboard', 'smartForm', formId] as const,
  smartFormQuestions: (formId: number) => ['onboard', 'smartForm', formId, 'questions'] as const,
  setupPackages: (offerId: number) => ['onboard', 'offers', offerId, 'setupPackages'] as const,
  setupPackageOptions: (offerId: number) =>
    ['onboard', 'offers', offerId, 'setupPackageOptions'] as const,
  setupPackage: (id: number) => ['onboard', 'setupPackages', id] as const,
  setupPackageAudit: (id: number) => ['onboard', 'setupPackages', id, 'audit'] as const,
  portalState: (token: string) => ['onboard', 'portal', token, 'state'] as const,
  portalContract: (token: string) => ['onboard', 'portal', token, 'contract'] as const,
  setupPortalState: (token: string) => ['onboard', 'setupPortal', token, 'state'] as const
};
